import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'

export const StepsDescription = observer(() => {
    const { t } = useTranslation()

    return (
        <div>
            1. {t('BankAccountCreate.alerts.nextSteps.changeAccount.steps.proceedToOutlets')} <br />
            2. {t('BankAccountCreate.alerts.nextSteps.changeAccount.steps.select')} <br />
            3. {t('BankAccountCreate.alerts.nextSteps.changeAccount.steps.pressEdit')}
        </div>
    )
})
